import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="pt-12 pb-8 md:pt-16 md:pb-12 px-4 md:px-6 lg:px-8 bg-white" data-id="element-125">
      <div className="max-w-4xl mx-auto mt-4" data-id="element-126">
        {/* Headline Block — Centered */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6" data-id="element-127">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-black text-black leading-[1.15] tracking-tight uppercase" data-id="element-128">
            Transformá cualquier ambiente viejo de tu casa en un espacio moderno
            y renovado en solo <span className="text-orange" data-id="element-129">4 Horas</span>
          </h1>
          <p className="text-base md:text-lg lg:text-xl font-medium text-black/70 mt-3 max-w-2xl mx-auto leading-snug" data-id="element-130">
            Sin demolición, sin albañiles y gastando mucho menos de lo que te
            imaginás.
          </p>
        </motion.div>

        {/* Premium Pills */}

        {/* Product Mockup — Centered */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex justify-center mb-6" data-id="element-131">
          <img src="https://cdn.magicpatterns.com/uploads/9sNFsBDRAZsjBiznkbsfN6/Ebook.png" alt="Renovación Sin Obras — Sistema Completo para Transformar tu Casa en 4 Horas" className="w-full max-w-sm rounded-xl shadow-md" data-id="element-132" />
        </motion.div>

        {/* CTA + Trust */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-center" data-id="element-133">
          <a href="https://bibliadigital.myshopify.com//cart/add?id=47688902443165&quantity=1" onClick={() => {
          if (typeof (window as any).fbq === 'function') (window as any).fbq('track', 'AddToCart');
        }} className="inline-block w-full md:w-auto text-center bg-orange text-white font-black text-base px-8 py-3.5 rounded-lg shadow-sm hover:shadow-md hover:scale-[1.02] transition-all duration-300 ease-out uppercase tracking-wide" data-id="element-134">
            QUIERO MI RENOVACIÓN
          </a>
          <p className="mt-2.5 text-xs text-black/50 font-bold uppercase tracking-wider" data-id="element-135">
            Acceso inmediato · Pago único · Garantía 30 días
          </p>
        </motion.div>
      </div>
    </section>;
}